
import { useHistory, useLocation, useParams } from "react-router-dom";
import { createElement, useCallback, useEffect, useState } from "react";
import SwipeableViews from "react-swipeable-views";
import {
    Button,
    Content,
    ContentHeader,
    PageTabsData,
    UnderlineTabs
} from "src/app/components";

import CampaignScreens from '../../../CampaignScreens';
import { PageTitle } from 'src/app/components/Layout/header/HeaderTitle';
import { BakcIcon } from "src/app/components/Icons";
import SalesPromoDetailTabDetail from './SalesPromoDetailTabDetail';
import { SalesPromoDetailPathType } from './SalesPromoDetail.types';
import SalesPromoDetailTabParticipant from './SalesPromoDetailTabParticipant';
import SalesPromoDetailTabResult from './SalesPromoDetailTabResult';

const salesPromoTabs: PageTabsData<SalesPromoDetailPathType>[] = [
    {
        component: SalesPromoDetailTabDetail,
        permission: 'manage_campaign_sales_promo.read',
        value: 'DETAIL',
        label: 'Detail',
        path: 'detail'
    },
    {
        component: SalesPromoDetailTabParticipant,
        permission: 'manage_campaign_sales_promo.read',
        value: 'PARTICIPANT',
        label: 'Participant List',
        path: 'participant',
    },
    {
        component: SalesPromoDetailTabResult,
        permission: 'manage_campaign_sales_promo.read',
        value: 'RESULT',
        label: 'Result',
        path: 'result',
    },
]

export default function SalesPromoDetailTabPage() {
    const history = useHistory();
    const location = useLocation();
    const [pageTabs, setPageTabs] = useState({
        index: 0,
        data: salesPromoTabs
    });
    const { id, path } = useParams<{ id: string, path: string }>();

    const renderItem = (item: PageTabsData, index: number) => (
        <div key={item.path} style={{ display: index === pageTabs.index ? 'block' : 'none' }}>
            {index === pageTabs.index && createElement(item.component, { ...item, title: item.label })}
        </div>
    );


    const baseRoute = CampaignScreens.DETAIL_SALES_PROMO.PATH

    const changeTab = useCallback((vitem: PageTabsData<string>, index: number) => {
        const route = baseRoute.replace(':id', id).replace(':path', vitem.path);
        history.replace(`${route}`);
        setPageTabs(prev => ({ ...prev, index }));
    }, [id, history]);


    useEffect(() => {
        const targetIndex = salesPromoTabs.findIndex(el => el.path === path);
        if (targetIndex !== -1 && targetIndex !== pageTabs.index) {
            changeTab(salesPromoTabs[targetIndex], targetIndex);
        }
    }, [location.pathname]); // ✅ Fixes infinite loop

    const breadcrumbs = [
        {
            isActive: false,
            path: [CampaignScreens.LIST_SALES_PROMO.PATH].join(),
            title: "Sales Promotion"
        },
        { isActive: false, path: '', title: '', isSeparator: true },
    ];

    return (
        <>
            <Button
                className={"mb-4"}
                startIcon={BakcIcon}
                variant="text"
                onClick={() => history.replace("/campaign/list/sales-promo")}
            >Back</Button>
            <Content>
                <ContentHeader title={'Detail Sales Promotion'}>
                    <UnderlineTabs
                        onChange={changeTab}
                        index={pageTabs.index}
                        items={pageTabs.data}
                    />
                </ContentHeader>
                <PageTitle description="Detail" breadcrumbs={breadcrumbs}>
                    Campaign
                </PageTitle>
                <SwipeableViews disableLazyLoading={false} index={pageTabs.index} className='px-8 py-6'>
                    {pageTabs.data.map(renderItem)}
                </SwipeableViews>
            </Content>
        </>
    );
}
